import axios from 'axios';
import { playerTypes, userTypes } from './_actionTypes';
import { to, history} from '../_helpers';
import {alertActions} from './';

const fetchPlayers = (gameId) => async dispatch => {
    const [err, res] = await to(axios.get(`/api/games/${gameId}/players`));
    if(res) {
        dispatch({ type: playerTypes.FETCH_PLAYERS, payload: res.data });
    } else {
        dispatch(alertActions.error(err.response.data.error.details[0].message));
        dispatch({
            type: playerTypes.FETCH_PLAYERS_FAILURE,
            payload: err.response
        });
    }
}

const addPlayer = (game, isGoalie) => async dispatch => {
    const [err, res] = await to(axios.post(`/api/games/${game.id}/players`,
        {isGoalie: isGoalie},
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ));

    if(res) {
        dispatch({
            type: playerTypes.ADD_PLAYER_SUCCESS,
            payload: res.data
        });
        dispatch({
            type: userTypes.UPDATE_CREDITS,
            payload: {
                gameCost: res.data.creditsPaid
            }
        });
        history.push('/dashboard');
    } else {
        dispatch(alertActions.error(err.response.data.error.details[0].message));
        dispatch({
            type: playerTypes.ADD_PLAYER_FAILURE,
            payload: err.response
        });
    }
}

const removePlayer = (game, isGoalie) => async dispatch => {
    const [err, res] = await to(axios.delete(`/api/games/${game.id}/players`));
    if(res) {
        dispatch({
            type: playerTypes.REMOVE_PLAYER_SUCCESS,
            payload: {gameId: game.id, isGoalie: isGoalie}
        });
        dispatch({
            type: userTypes.UPDATE_CREDITS,
            payload: {
                gameCost: - res.data.creditsReturned
            }
        });
        history.push('/dashboard');
    } else {
        dispatch(alertActions.error(err.response.data.error.details[0].message));
        dispatch({
            type: playerTypes.REMOVE_PLAYER_FAILURE,
            payload: err.response
        });
    }
}

const editPlayerTeam = (gameId, userId, team) => async dispatch => {
    const params = {userId, team};
    const [err, res] = await to(axios.patch(`/api/games/${gameId}/players`,
        params,
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ));

    if(res){
        dispatch({
            type: playerTypes.EDIT_PLAYER_TEAM_SUCCESS,
            payload: res.data
        });
        dispatch(alertActions.success('Player Team Updated!'));
    }else{
        dispatch({
            type: playerTypes.EDIT_PLAYER_TEAM_FAILURE,
            payload: err.response
        });
    }
}

export const playerActions = {
    fetchPlayers, addPlayer, removePlayer, editPlayerTeam
}


// WEBPACK FOOTER //
// ./src/actions/player.actions.js